<template>
    <div>
        <div class="usePowerUnitBodys custom-scrollbar router">
            <el-col :span="5">
                <div class="top">能源品质监控</div>
                <div v-for="(item, index) in list" :key="index" class="a">
                    <el-row class="text_top">
                        <el-col :span="9">{{ item.name }}</el-col>
                        <el-col :span="5">{{ item.standard }}</el-col>
                        <el-col :span="5">{{ item.current }}</el-col>
                        <el-col :span="5">{{ item.state }}</el-col>
                    </el-row>
                    <div v-if="item.list.length > 0" class="list">
                        <el-row class="list_tab" v-for="(items, i) in item.list" :key="i">
                            <el-col :span="9" :title="items.name">{{ items.name }}</el-col>
                            <el-col :span="5">{{ items.standard }}</el-col>
                            <el-col :span="5">{{ items.rtValue ? items.rtValue : '--' }}</el-col>
                            <el-col :span="5" :class="items.state == '正常' ? 'p' : 'p2'">{{ items.state }}</el-col>
                        </el-row>
                    </div>
                </div>
                <div>
                    <div class="top">设备运行报警</div>
                    <div>
                        <el-row class="texta_top">
                            <el-col :span="5">关联对象</el-col>
                            <el-col :span="5">类型</el-col>
                            <el-col :span="8">内容</el-col>
                            <el-col :span="6">时间</el-col>
                        </el-row>
                        <div style="overflow-y: hidden;" class="list monitor">
                            <div class="marquee">
                                <el-row class="list_tab row" v-for="(item, i) in equipment" :key="i">
                                    <el-col :span="5">{{ item.linkobject }}</el-col>
                                    <el-col :span="5">{{ item.typeName }}</el-col>
                                    <el-col :span="8" class="maxwinth">{{ item.description }}</el-col>
                                    <el-col :span="6">{{ new Date(item.time).format('yyyy/MM/dd hh:mm:ss') }}
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="14">
                <div class="aut">
                    <div class="flex aut_a" style="line-height: 34px;">
                        <div style="font-size: 20px;">安全运行天数：</div>
                        <div style="font-size: 30px;">{{ safetyDate }}</div>
                        <div style="font-size: 20px;margin-left: 3%;">天</div>
                    </div>
                    <!-- <img style="max-width: 100%;" src="../../../../assets/deyinkanban/kanban.jpg" /> -->
                </div>
            </el-col>
            <el-col :span="5">
                <div>
                    <div class="top">系统耗能监测</div>
                    <!-- <div class="tab-label_a">
                        <div class="tab-label-span" @click="changSelectIndex(0)" :style="tabStyleIndex('0')">
                            <span>日</span>
                        </div>
                        <div class="tab-label-span" @click="changSelectIndex(1)" :style="tabStyleIndex('1')">
                            <span>月</span>
                        </div>
                        <div class="tab-label-span" @click="changSelectIndex(2)" :style="tabStyleIndex('2')">
                            <span>年</span>
                        </div>
                    </div> -->
                    <div class="flex a">
                        <div v-for="(item, i) in consumption" :key="i" class="flex"
                            style="width: 48%;margin-bottom: 5px;">
                            <img class="img" :src="item.img" />
                            <div class="color2">
                                <div class="t" style="font-weight: 700;">{{ item.amount }}</div>
                                <div style="font-size: 16px;" class="color1">{{ item.data.value ? item.data.value : 0 }}
                                </div>
                                <div class="t" style="font-weight: 700;">单吨</div>
                                <div class="t">{{ item.data.singleTon ? item.data.singleTon : 0 }}</div>
                                <div class="t">同比 {{ item.data.compare ? item.data.compare + '%' : 0 + '%' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="top flex">单吨用能趋势分析</div>
                    <!-- <el-row class="textb_top">
                        <el-col :span="6">用电量</el-col>
                        <el-col :span="6">用水量</el-col>
                        <el-col :span="6">用汽量</el-col>
                        <el-col :span="6">折标煤</el-col>
                    </el-row> -->
                    <div>
                        <vchart :style="chart" ref='columnar' @itemchanged="Itemchanged"></vchart>
                    </div>
                </div>
                <div class="peakAndFlatBody">
                    <div class="peakContent">
                        <div class="top flex">碳排放量分析</div>
                        <div>
                            <vchart :style="chart2" ref='vchartPie'></vchart>
                        </div>
                        <div class="tab-label">
                            <div class="tab-label-span" @click="getRoundBarList(2)" :style="tabStyle('2')">
                                <span>月</span>
                            </div>
                            <div class="tab-label-span" @click="getRoundBarList(4)" :style="tabStyle('4')">
                                <span>年</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </div>
    </div>
</template>

<script>
import vchart from '@/components/module/chart/vchart.vue'
export default {
    components: {
        vchart,
    },
    data() {
        return {
            selectIndex: 0,//0为日 1为月 2为年
            chart: '',
            chart2: '',
            selectTab: 0, //0为月 1为年
            list: [{
                name: '电质量指标',
                standard: '标准值',
                current: '当前值',
                state: '当前状态',
                list: []
            }, {
                name: '水质量指标',
                standard: '标准值',
                current: '当前值',
                state: '当前状态',
                list: []
            }, {
                name: '蒸汽质量指标',
                standard: '标准值',
                current: '当前值',
                state: '当前状态',
                list: []
            }, {
                name: '压缩空气质量指标',
                standard: '标准值',
                current: '当前值',
                state: '当前状态',
                list: []
            }, {
                name: '冰水质量指标',
                standard: '标准值',
                current: '当前值',
                state: '当前状态',
                list: []
            }],
            equipment: [],//设备
            consumption: [{
                img: require('../../../../assets/deyinkanban/dianliang.png'),
                amount: '电量',
                data: {}
            }, {
                img: require('../../../../assets/deyinkanban/zhebiaomei.png'),
                amount: '折标煤',
                data: {}
            }, {
                img: require('../../../../assets/deyinkanban/shuiliang.png'),
                amount: '水量',
                data: {}
            }, {
                img: require('../../../../assets/deyinkanban/tan.png'),
                amount: '碳排放',
                data: {}
            }, {
                img: require('../../../../assets/deyinkanban/zhengqi.png'),
                amount: '蒸汽',
                data: {}
            }],
            option: {},//碳排放
            zoption: {},//单吨用能
        }
    },
    computed: {
        tabStyle() {
            return index => {
                if (index == this.selectTab) {
                    return {
                        'background': '#178fa0'
                    }
                }
            }
        },
        tabStyleIndex() {
            return index => {
                if (index == this.selectIndex) {
                    return {
                        'background': '#178fa0'
                    }
                }
            }
        },
        nowUnit() {
            return this.$store.unitStore.getters.getNowUnit;
        },
        safetyDate() {
            return Math.floor(
                (Date.now() - this.nowUnit.joinTime) / (24 * 3600 * 1000)
            );
        },
    },

    mounted() {
        this.chart = 'width: 100%;height: 220px;'
        this.chart2 = 'width: 100%;height: 240px;'
        //初始化图表
        this.init()
        //获取左侧数据
        this.getKanbanRtValue()
        //看板监测数据
        this.getKanbanEnergyMonitoring()
        //饼状图获取
        this.getRoundBarList(2)
        setInterval(this.set, 30000)
        setInterval(this.getKanbanRtValue, 60000)
    },
    methods: {
        //饼状图
        getRoundBarList(data) {
            this.selectTab = data;
            this.$api.deviceApi.getRoundBarList(data, respon => {
                this.option.series[0].data = respon
                this.$refs.vchartPie.setData(this.option, true)
            })
        },
        //看板监测数据
        getKanbanEnergyMonitoring() {
            this.$api.deviceApi.getKanbanEnergyMonitoring('', respon => {
                //电量
                this.consumption[0].data = respon.power
                //煤
                this.consumption[1].data = respon.coal
                //水量
                this.consumption[2].data = respon.water
                //碳
                this.consumption[3].data = respon.carbom
                //蒸汽
                this.consumption[4].data = respon.steam
                //数据保留两位小数
                this.consumption.map(v => {
                    v.data.singleTon = v.data.singleTon.toFixed(2)
                    v.data.value = v.data.value.toFixed(2)
                })
            })
        },
        //看板左侧数据
        getKanbanRtValue() {
            this.$api.deviceApi.getKanbanRtValue('', respon => {
                //电质量
                this.list[0].list = respon.powerQualityList
                //水质量
                this.list[1].list = respon.waterQualityList
                //蒸汽质量
                this.list[2].list = respon.steamQualityList
                //冰水质量
                this.list[4].list = respon.iceWaterList
                //压缩空气质量
                this.list[3].list = respon.compressedAirList
            })
        },
        //设备运行报警
        set() {
            this.$api.eventApi.searchEventListByUser(undefined, this.nowUnit.id, '', -1, -1, getValueIfNoNull(this.nowDevice, {}).no, new Date(new Date().toLocaleDateString()).getTime(), Date.now(), 1, 20, '', respon => {
                let data = []
                //循环两次达到轮播无缝连接效果
                for (let i = 0; i < 2; i++) {
                    for (let j = 0; j < respon.data; j++) {
                        data.push(respon.data[j])
                    }
                }
                this.equipment = data
            })
        },
        //echarts初始化
        init() {
            this.option = {
                tooltip: {
                    trigger: 'item',
                },
                color: ['#4946fb', '#be2ef9', '#468bff'],
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ["50%", "70%"],
                        label: {
                            normal: {
                                textStyle: {
                                    fontWeight: 100,
                                    fontSize: 12,
                                    color: '#FFF'
                                },
                                formatter: '{b}\n{d}%'
                            }
                        },
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
            let data = new Date();
            let y = data.getFullYear();
            let m = data.getMonth() + 1;
            let MonthDayNum = new Date(y, m, 0).getDate();
            let list = []
            for (let i = 1; i < MonthDayNum + 1; i++) {
                list.push(i > 9 ? i + '日' : '0' + i + '日')
            }
            this.zoption = {
                color: ['#1b93f3', '#de2e74', '#f29961', '#86e4f5'],
                legend: {
                    y: 'top',
                    top: '5px',
                    textStyle: {
                        color: "#8696de",
                    },
                    selectedMode: 'single'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: list,
                    splitLine: {
                        show: false // 不显示网格线
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#8696de"
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#8696de",
                        }
                    },

                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false, // 不显示坐标轴线
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#8696de",
                        }
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        animation: false
                    },
                    formatter: function (params) {
                        var html = params[0].name + "<br/>";
                        for (var i = 0; i < params.length; i++) {
                            let name = params[i].seriesName == '用电量' ? 'kwh/t' : params[i].seriesName == '用水量' ? 'm³/t' : 't/t'
                            html +=
                                params[i].marker + params[i].seriesName +
                                params[i].value + name + "<br/>";
                        }
                        return html
                    },
                },
                series: []
            }
            this.$api.deviceApi.getColumnBarList('', res => {
                let data = []
                res.map(v => {
                    if (v.name == '用电量' && v.singleTon != 0) {
                        this.zoption.visualMap = {
                            top: 10,
                            right: 10,
                            pieces: [{
                                lt: v.singleTon,
                                color: '#7cf592'
                            }, {
                                gte: v.singleTon,
                                color: 'red'
                            }],
                            show: false
                        }
                    }
                    let markLine = {
                        symbol: ['none', 'none'],
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#F04134',
                                },
                                label: {
                                    show: true,
                                    position: 'end',
                                    distance: 20,
                                    textStyle: {
                                        color: '#F04134',
                                        fontSize: 30,
                                    },
                                }
                            }
                        },
                        data: [{
                            yAxis: v.singleTon == 0 ? '' : v.singleTon,
                        }]
                    }
                    data.push({
                        name: v.name,
                        data: v.data,
                        type: v.type,
                        markLine: markLine
                    })
                })
                this.zoption.series = data
                this.$refs.columnar.setData(this.zoption, true);
            })
            this.$refs.vchartPie.setData(this.option, true)
        },
        changSelectIndex(value) {
            this.selectIndex = value;
        },
        Itemchanged(item) {
            this.zoption.series.map((v,i) => {
                if (v.name == item.name && v.markLine) {
                    let data = v.markLine.data[0].yAxis
                    this.zoption.visualMap = {
                        top: 10,
                        right: 10,
                        pieces: [{
                            lt: data,
                            color: '#7cf592'
                        }, {
                            gte: data,
                            color: 'red'
                        }],
                        show: false
                    }
                }
            })
            this.zoption.legend.selected = item.selected
            this.$refs.columnar.setData(this.zoption, true);
        }
    }

}
</script>

<style scoped>
@import url("../../../../components/css/usePowerUnit.css");

.top {
    color: #64e8f0;
    font-size: 16px;
    padding-left: 55px;
    background: url('../../../../assets/deyinkanban/title.png');
    background-size: 100% 100%;
    margin: 10px 0;
    font-weight: 700;
    height: 34px;
    line-height: 34px;
}

.router {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    height: 100%;
    display: inline-block;
    overflow: auto;
}

.usePowerUnitBodys {
    background: #08265f;
}

.usePowerUnitBodys {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    height: calc(100% - 35px);
    padding: 0 1%;
    overflow: auto;
    /* height: 100%; */
}

.text_top {
    background-color: #0165fb;
    color: #FFF;
    padding: 5px 0;
    font-weight: 800;
    text-align: center;
}

.flex {
    display: flex;
}

.texta_top {
    color: #4292f3;
    padding-bottom: 10px;
    font-weight: 800;
    text-align: center;
}

.textb_top {
    color: #2161f9;
    text-align: center;
    border-top: solid 1px;
    border-bottom: solid 1px;
    padding: 5px 0;
    font-weight: 600;
    width: 90%;
    margin: 0 auto;
}

.a {
    margin-bottom: 3%;
}

.list {
    max-height: 100px;
    overflow-y: auto;
}

.list_tab {
    border-top: solid 1px #0165fb;
    color: #FFF;
    padding: 10px 0;
    text-align: center;
    font-weight: 600;
}

.list::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.list::-webkit-scrollbar-track-piece {
    background-color: rgb(17, 16, 16, 0);
    -webkit-border-radius: 6px;
}

.list::-webkit-scrollbar-thumb:vertical {
    background-color: #4deefc;
    -webkit-border-radius: 6px;
}

.p {
    color: #7cf592;
}

.p2 {
    color: #d43390;
}

/* .list .list_tab:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  } */

.img {
    height: 70px;
    width: 70px;
    margin: auto 10px auto;
}

.color1 {
    color: #97edf8;
}

.color2 {
    color: #FFF;
}

.t {
    font-size: 14px;
    margin-bottom: 5px;
}

.a {
    flex-wrap: wrap;
}

.columnar {
    width: 100%;
    height: 250px;
}

.tab-label_a {
    width: 180px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: auto;
    /* position: relative;
    left: 55%;
    bottom: 100%; */
}

.tab-label {
    width: 180px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    left: 55%;
    bottom: 97%;
}

.tab-label-span {
    width: 30%;
    height: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #12408A;
    border-radius: 10%;
    font-size: .12rem;
    /* z-index: 999; */
}

.tab-label-span span {
    color: white;
}

.peakAndFlatBody {
    height: 274px;
}

.peakContent {
    height: calc(100% - 31px);
}

.titlee {
    width: 100%;
    color: #9ed3fe;
    padding: 10px 0;
    border-bottom: solid 1px;
    border-image: linear-gradient(90deg, rgba(0, 216, 247, 0) 0%, #00afed 50%, rgba(0, 216, 247, 0) 100%) 2 2 2 2;
}

.aut {
    background-image: url('../../../../assets/deyinkanban/kanban2.jpg');
    background-size: 100% 100%;
    height: 100%;
    width: 99%;
    margin: 0 auto;
    color: #FFF;
}

.aut_a {
    line-height: 34px;
    justify-content: center;
    padding-top: 10%;
    padding-bottom: 10px;
    width: 50%;
    margin: 0 auto;
    font-weight: 800;
    letter-spacing: 3px;
    border-bottom: solid 2px;
    border-image: linear-gradient(90deg, rgba(0, 216, 247, 0) 0%, #82dff4 50%, rgba(0, 216, 247, 0) 100%) 2 2 2 2;
}


/* ------------------------------------------------------------动画 */
@keyframes row {

    0% {}

    100% {
        transform: translateY(-50%);
    }
}

/* 调用动画 */
.monitor .marquee {
    /* //infinite永久调用动画 */
    animation: row 15s linear infinite;
}

/*鼠标划入 停止动画 */
.monitor .marquee:hover {
    animation-play-state: paused;
}

.maxwinth {
    max-width: 115px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>